import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { cloneDeep, filter } from 'lodash';

import { useSelector, useDispatch } from '../common/react-redux-hooks';
import DictionarySearchV2 from '../dictionary/DictionarySearchV2';
import * as urls from '../../actions/urlTypes';
import {
  CORRCLUSTER_FEATUREID,
  CLUSTER_CORRESPONDENCE_MODULE,
  DV_DEFAULT_VALUE,

} from '../../constants';
import {
  updateCaCProjectStudy,
  updateCaCProjectWeightType,
  addToPassive,
  handleViewSwitch,
  showHideDataPoint,
  getCACProjectDetails,
  getClusterProjectDetails,
  getCACProjectContourMap,
} from '../../actions/cacActions';
import { updateCrosstabGridTitleHeader } from '../../actions/crosstabActions';
import {
  getSampleWeighted,
  getSampleWeightedData,
  clearSampleWeighted,
  updateSampleWeighted,
  addDefaultBase,
} from '../../actions/cacAutoCodeActions';
import {
  CAC_LEFT_PANEL_VIEW_LABEL,
  CAC_COLUMN_ROW_CROSSTAB_MIN_COUNT,
  CAC_MODULE_TITLE,
  INSUFFICIENT_DATA_MODAL_TEXT,
  HANDLE_VIEW_SWITCH_EVENT,
} from './CacConstants';
import PortalModal from '../common/Modal/PortalModal';
import GenericButton from '../common/GenericButton';
import { getApiRequestParameter } from '../../util/cacUtils';
// import cacValidateStudyModal from './modals/cacValidateStudyModal';

const currClusterModalStyle = {
  width: '50%',
  left: '25%',
  top: '30%',
};
const currClusterModalStyle2 = {
  width: '560px',
  left: 'calc(50vw - 280px)',
  top: '30%',
};

function CacBuildComponent({ project }) {
  const dispatch = useDispatch();
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [minimumLimitModal, setMinimumLimitModal] = useState(false);
  const [currentProjectId, setCurrentProjectId] = useState(project.projectId);
  const [isShowing, setIsShowing] = useState(false);
  const [invalidDataList, setInvalidData] = useState({});
  const [studyChangeData, setStudyChangeData] = useState({});
  const [gridDataList, setGridDataList] = useState({});

  const dictionarySearchRef = useRef();

  const { studies, loginResponse, accountId } = useSelector(state => ({
    studies: state.study.studies,
    loginResponse: state.login.loginResponse,
    accountId: state.account.activeAccountId,
  }));
  const { userId, currentAccountId } = useSelector(
    state => state.login.loginResponse.data
  );
  const getGridData = () => ({
    // kpiInfo: this.props.kpiInfo,
    ScratchDataGrid: [],
    BasesDataGrid: project.base,
    RowsDataGrid: project.rows,
    ColumnsDataGrid: project.columns,
    RecycleElements: [{}],
  });

  const filterData = (listName, gridName, validateData) => {
    const updatedList = [];
    const invalidData = invalidDataList;
    invalidData[gridName] = {};
    if (validateData[listName]) {
      validateData[listName].forEach(elems => {
        if (elems.valid) {
          project[gridName].forEach(data => {
            if (elems.expression === data.keyword) {
              updatedList.push(data);
            }
          });
        } else {
          invalidData[gridName][elems.expression] = elems.label;
        }
      });
    }

    if (Object.keys(invalidData[gridName]).length === 0) {
      delete invalidData[gridName];
    }
    setInvalidData(invalidData);
    return updatedList;
  };

  const cancelStudyOrWeightChange = () => {
    setIsShowing(false);
    setStudyChangeData({});
    setInvalidData({});
    setGridDataList({});
  };

  const handleCancelClick = () => {
    cancelStudyOrWeightChange();
    dictionarySearchRef.current.setStudyAsPreviousStudy(project.study);
  };

  const filterBaseList = baseList => {
    return baseList.filter(expr => expr.keyword !== 'StudyUniverseKey');
  };

  const getSampleWeightedOfKPIs = () => {
    const selectedStudy = studyChangeData.selectedStudy;
    const updatedWeightType = studyChangeData.updatedWeightType;

    let sampleWeightedParams = {
      token: loginResponse.data.token,
      uid: loginResponse.data.uid,
      accountId,
      productNo: selectedStudy.pn,
      weightType: updatedWeightType.wt,
      divisor: updatedWeightType.dv || DV_DEFAULT_VALUE,
      weightChange: true,
    };
    const baseLists = filterBaseList(gridDataList.baseList || project.base);
    const columnsLists = gridDataList.colList || project.columns;
    const rowsLists = gridDataList.rowList || project.rows;
    if (baseLists && baseLists.length > 0) {
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'BasesDataGrid',
        targetGrid: 'BasesDataGrid',
        expressionList: baseLists.map(expr => expr.keyword),
        selectedNames: baseLists.map(expr => expr.title),
        originalNames: baseLists.map(expr => expr.originalTitle),
      };
      dispatch(getSampleWeighted(sampleWeightedParams));
    } else {
      dispatch(clearSampleWeighted('BasesDataGrid'));
    }

    if (columnsLists && columnsLists.length > 0) {
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'ColumnsDataGrid',
        targetGrid: 'ColumnsDataGrid',
        expressionList: columnsLists.map(expr => expr.keyword),
        selectedNames: columnsLists.map(expr => expr.title),
        originalNames: columnsLists.map(expr => expr.originalTitle),
      };
      dispatch(getSampleWeighted(sampleWeightedParams));
    } else {
      dispatch(clearSampleWeighted('ColumnsDataGrid'));
    }

    if (rowsLists && rowsLists.length > 0) {
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'RowsDataGrid',
        targetGrid: 'RowsDataGrid',
        expressionList: rowsLists.map(expr => expr.keyword),
        selectedNames: rowsLists.map(expr => expr.title),
        originalNames: rowsLists.map(expr => expr.originalTitle),
      };
      dispatch(getSampleWeighted(sampleWeightedParams));
    } else {
      dispatch(clearSampleWeighted('RowsDataGrid'));
    }
    cancelStudyOrWeightChange();
  };

  const handleContinueClick = () => {
    if (studyChangeData.studyChanged) {
      dispatch(
        updateCaCProjectStudy(
          project.projectId,
          studyChangeData.selectedStudy,
          studyChangeData.updatedWeightType
        )
      );
    } else {
      dispatch(
        updateCaCProjectWeightType(
          project.projectId,
          studyChangeData.updatedWeightType
        )
      );
    }
    getSampleWeightedOfKPIs();
  };

  const validateCACData = (projectId, updatedWeightType, selectedStudy) => {
    const baseList = filterBaseList(project.base);
    const colExpressionList = project.columns.map(expr => expr.keyword);
    const rowExpressionList = project.rows.map(expr => expr.keyword);
    if (
      baseList.length > 0 ||
      colExpressionList.length > 0 ||
      rowExpressionList.length > 0
    ) {
      const url = `${urls.ROOT_URL}/crosstab/${loginResponse.data.uid}/${accountId}/validate`;
    axios({
      url,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data: {
        products: [`${selectedStudy.pn}`],
        weightType: updatedWeightType.wt,
        divisor: updatedWeightType.dv || DV_DEFAULT_VALUE,
        title: 'Title Not Needed',
        oldProductNo: project.study.pn,
        baseList: baseList.map(base => base.keyword),
        baseHeaderList: baseList.map(base => base.title),
        colExpressionList,
        colHeaderList: project.columns.map(expr => expr.title),
        rowExpressionList,
        rowHeaderList: project.rows.map(expr => expr.title),
      },
    })
      .then(response => {
        const validateData = response.data.data;
        const baseList = filterData('baseList', 'base', validateData);
        const colList = filterData('colList', 'columns', validateData);
        const rowList = filterData('rowList', 'rows', validateData);

        setGridDataList({ baseList, colList, rowList });
        if (Object.keys(invalidDataList).length > 0) {
          setIsShowing(true);
        } else {
          handleContinueClick();
        }
      })
        .then(response => {
          const validateData = response.data.data;
          const baseList = filterData('baseList', 'base', validateData);
          const colList = filterData('colList', 'columns', validateData);
          const rowList = filterData('rowList', 'rows', validateData);

          setGridDataList({ baseList, colList, rowList });
          if (Object.keys(invalidDataList).length > 0) {
            setIsShowing(true);
          } else {
            handleContinueClick();
          }
        })
        .catch(response => console.warn(response));
    } else {
      handleContinueClick();
    }
  };

  const handleStudyChange = (selectedStudy, updatedWeightType) => {
    if (selectedStudy !== undefined) {
      const weightType = cloneDeep(updatedWeightType);
      weightType.dv = weightType.dv || DV_DEFAULT_VALUE;
      setStudyChangeData({
        updatedWeightType: weightType,
        selectedStudy,
        studyChanged: true,
      });
    }
  };

  useEffect(() => {
    if (studyChangeData.selectedStudy) {
      validateCACData(
        project.projectId,
        studyChangeData.updatedWeightType,
        studyChangeData.selectedStudy
      );
    }
  }, [studyChangeData]);

  const handleChangeWeightType = updatedWeightType => {
    if (updatedWeightType !== undefined) {
      const weightType = cloneDeep(updatedWeightType);
      weightType.dv = weightType.dv || DV_DEFAULT_VALUE;
      setStudyChangeData({
        updatedWeightType: weightType,
        selectedStudy: project.study,
        studyChanged: false,
      });
    }
  };

  const callShowHideDataPoint = (keyType, index, isShow) => {
    const gridData = keyType === 'row' ? project.rows : project.columns;
    const gridFilterData = filter(gridData, item => item.isShow === true);
    const passives =
      keyType === 'row' ? project.passiveRows : project.passiveCols;
    if (gridFilterData.length - passives.length > 3 || isShow) {
      dispatch(showHideDataPoint(keyType, project.projectId, index));
    } else {
      setMinimumLimitModal(true);
    }
  };

  const moduleActions = {
    getSampleWeighted: params => dispatch(getSampleWeighted(params)),
    getSampleWeightedData: params => dispatch(getSampleWeightedData(params)),
    updateSampleWeighted: (gridData, targetGrid) =>
      dispatch(updateSampleWeighted(gridData, targetGrid)),
    clearSampleWeighted: params => dispatch(clearSampleWeighted(params)),
    updateCrosstabGridTitleHeader: params =>
      dispatch(updateCrosstabGridTitleHeader(params)),
    addToPassive: (gridType, projectId, index) =>
      dispatch(addToPassive(gridType, project.projectId, index)),
    handleShowHide: (keyType, index, isShow) =>
      callShowHideDataPoint(keyType, index, isShow),
    showMinLimitPopup: () => setMinimumLimitModal(true),
    addDefaultBase: () => dispatch(addDefaultBase()),
  };

  const handleRun = () => {
    const { rows, columns } = project;
    const filteredRows = rows.filter(row => !row.isPassive);
    const filteredCols = columns.filter(col => !col.isPassive);
    if (
      filteredRows.length >= CAC_COLUMN_ROW_CROSSTAB_MIN_COUNT &&
      filteredCols.length >= CAC_COLUMN_ROW_CROSSTAB_MIN_COUNT
    ) {
      dispatch(handleViewSwitch(CAC_LEFT_PANEL_VIEW_LABEL, project.projectId));
      const projectObj = getApiRequestParameter(
        project,
        CAC_LEFT_PANEL_VIEW_LABEL,
        '',
        HANDLE_VIEW_SWITCH_EVENT
      );
      dispatch(
        getCACProjectDetails({ userId, currentAccountId, ...projectObj })
      );
      dispatch(
        getClusterProjectDetails({ userId, currentAccountId, ...projectObj })
      );
      dispatch(
        getCACProjectContourMap({ userId, currentAccountId, ...projectObj }) // jed (does this go here?)
      );
    } else {
      setMinimumLimitModal(true);
    }
  };

  useEffect(() => {
    if (currentProjectId !== project.projectId) {
      setRefreshFlag(!refreshFlag);
      setCurrentProjectId(project.projectId);
    }
  }, [project.projectId]);

  const renderInavlidData = gridName => {
    const dataList = [];
    if (invalidDataList && invalidDataList[gridName]) {
      for (const key in invalidDataList[gridName]) {
        dataList.push(<div>{`${key}: ${invalidDataList[gridName][key]}`}</div>);
      }
    }

    return dataList;
  };

  const renderValidationMessage = () => {
    return (
      <div>
        <div className="row margin-0">
          <div className="large-12 columns">
            <h4>Below data points are not available in the requested study.</h4>
            <div>Base : {renderInavlidData('base')}</div>
            <div>Columns : {renderInavlidData('columns')}</div>
            <div>Rows : {renderInavlidData('rows')}</div>
            <h5>
              Click CONTINUE to return to the editor and proceed with the change
              study request. Validated data points will be transferred but all
              other report selections will be reset. We strongly suggest
              exporting your analysis prior to proceeding.
            </h5>
            <h5>
              Click CANCEL to return to your previous study and maintain their
              current analysis.
            </h5>
          </div>
        </div>
        <div className="modal-footer">
          <GenericButton
            name="CONTNUE"
            btnStyle="button btn-cncl float-right"
            onBtnClick={() => handleContinueClick()}
          />
          <GenericButton
            name="CANCEL"
            btnStyle="button btn-cncl float-right btn-right-margin"
            onBtnClick={() => handleCancelClick()}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="crosstab-accordion">
      <div>
        <DictionarySearchV2
          data-test="Dictionary-v2"
          studies={studies}
          featureID={CORRCLUSTER_FEATUREID}
          BasesDataGridData={project.base}
          ColumnsDataGridData={project.columns}
          RowsDataGridData={project.rows}
          ScratchDataGridData={[]}
          recycleElements={project.RecycleGridData}
          weightTypes={project.weightTypes}
          sampleWeightedKPIs={{}}
          handleStudyChange={handleStudyChange}
          handleChangeWeightType={handleChangeWeightType}
          moduleStudy={project.study}
          gridData={getGridData()}
          trackerFn={() => {}}
          moduleAction={moduleActions}
          dictionaryTabsList={['dictionary', 'geography', 'definition']}
          scratchEnabled={false}
          rightGridList={['cacgrid']}
          // Add CRB if you want to see column/row/base in context menu and functions options.
          menuName={CLUSTER_CORRESPONDENCE_MODULE}
          handleRun={() => handleRun()}
          moduleName="Correspondence &amp; Cluster"
          mainMenuName="Essentials"
          noExpressionBox={false} // true in case expression box is not being used
          refreshFlag={refreshFlag}
          rowColBaseGrid
          isSingleBase
          windowHeight={{ height: 'calc(100vh - 87px)' }}
          isRunEnabled
          ref={dictionarySearchRef}
          breadcrumbFlag
        />
      </div>
      {/* <cacValidateStudyModal
        isShowing={isShowing}
        hide={() => setIsShowing(false)}
        handleContinueClick={() => handleContinueClick()}
        handleCancelClick={() => handleCancelClick()}
        dialogStyles={currClusterModalStyle}
        onCloseClicked={() => handleCancelClick()}
      /> */}
      <PortalModal
        isShowing={isShowing}
        data-test="PortalModal-1"
        // hide={() => setIsShowing(false)}
        title={`Data points can't be transferred`}
        dialogStyles={currClusterModalStyle}
        onCloseClicked={() => handleCancelClick()}
      >
        {renderValidationMessage()}
      </PortalModal>
      <PortalModal
        data-test="PortalModal-2"
        isShowing={minimumLimitModal}
        // hide={() => setMinimumLimitModal(false)}
        title={CAC_MODULE_TITLE}
        dialogStyles={currClusterModalStyle2}
        onCloseClicked={() => setMinimumLimitModal(false)}
      >
        <div>{INSUFFICIENT_DATA_MODAL_TEXT.split('|')[0]}</div>
        <div style={{ paddingBottom: '15px' }}>
          {INSUFFICIENT_DATA_MODAL_TEXT.split('|')[1]}
        </div>
        <div className="text-center">
          <GenericButton
            name="Ok"
            onBtnClick={() => setMinimumLimitModal(false)}
          />
        </div>
      </PortalModal>
    </div>
  );
}

CacBuildComponent.propTypes = {
  project: PropTypes.shape({
    RecycleGridData: PropTypes.instanceOf(Array),
    weightTypes: PropTypes.instanceOf(Object),
    study: PropTypes.instanceOf(Object),
    rows: PropTypes.arrayOf(PropTypes.object),
    columns: PropTypes.arrayOf(PropTypes.object),
    base: PropTypes.arrayOf(PropTypes.object),
    isBaseOpen: PropTypes.bool,
    isRowsOpen: PropTypes.bool,
    isColumnsOpen: PropTypes.bool,
    isPassivesOpen: PropTypes.bool,
    projectId: PropTypes.number,
    corrMapView: PropTypes.bool,
    chartView: PropTypes.instanceOf(Array),
    passiveRows: PropTypes.arrayOf(PropTypes.number),
    passiveCols: PropTypes.arrayOf(PropTypes.number),
    corrResponse: PropTypes.shape({
      cm: PropTypes.instanceOf(Array),
    }),
  }),
};

export default CacBuildComponent;
